import DealersList from "./DealersList";

export default DealersList;
